import styled from 'styled-components';
import {
  desktop_breakpoint,
  desktop_breakpoint_extended,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const LandDetailsStyles = styled.div`
  .land-search {
    width: 150px;
    a:link,
    a:visited,
    a:hover,
    a:active {
      align-items: center;
      color: ${Colors.primary.claytonBlue.standard};
      display: flex;
      flex-direction: row;
      text-decoration: none;

      svg {
        margin-top: 12px;

        * {
          fill: ${Colors.primary.claytonBlue.standard};
        }
      }
    }
  }
  .slider-wrapper .slide div.landscape img {
    object-fit: cover;
  }

  .land-top-section {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-bottom: 25px;
  }

  .status-indicator {
    align-items: center;
    display: flex;
    text-transform: uppercase;

    &:before {
      background-color: ${Colors.accent.claytonGreen.standard};
      border-radius: 50%;
      content: 'nil';
      display: block;
      font-size: 0;
      height: 6px;
      margin-right: 4px;
      width: 6px;
    }
  }

  .pending {
    &:before {
      background-color: ${Colors.accent.cheesePuff.standard};
    }
  }

  .land-header-info {
    border-bottom: 1px solid ${Colors.primary.black.tint};
    padding-bottom: 25px;

    h2 {
      margin-bottom: 10px;
    }

    .label.large,
    h5 {
      display: block;
      margin-bottom: 5px;
    }
  }

  .land-specs {
    color: ${Colors.primary.white.tint};
    padding-top: 25px;
  }

  .land-spec {
    align-items: center;
    display: flex;
    flex-direction: row;

    svg {
      height: 40px;
      margin-right: 10px;
      width: 40px;
    }
  }

  .calendar {
    svg {
      position: relative;
      left: -2px;
      filter: brightness(
        300%
      ); /* Used to lighten up the calendar svg until we have a 48x48 calendar svg */
    }
  }

  .control-dots {
    display: none;
  }

  .land-slideshow {
    margin: auto;
    margin-bottom: 50px;
    max-width: 600px;
    position: relative;
    width: 100%;

    img {
      transform: translate(0, 0);
    }

    .image-unavailable {
      display: flex;
      align-items: center;
      height: 100%;
      justify-content: center;
    }
  }

  .land-image-count {
    background-color: ${Colors.primary.black.standard};
    display: flex;
    height: 24px;
    justify-content: center;
    padding-top: 1px;
    position: absolute;
    right: 10px;
    top: 10px;
    width: 40px;

    .caption {
      color: ${Colors.primary.white.standard};
    }

    svg {
      height: 20px;
      margin-left: 5px;
      width: 20px;

      * {
        fill: ${Colors.primary.white.standard};
      }
    }
  }

  .land-info {
    align-self: flex-start;
    width: 100%;
  }

  .land-description,
  .land-location {
    margin-bottom: 25px;

    h2,
    h4,
    h6 {
      margin-bottom: 10px;
    }
  }

  .land-redundant-address {
    display: none;
  }

  .land-map {
    height: 400px;
  }

  .map-pin {
    background: url('/public-assets/images/map-pin.svg') no-repeat;
    background-size: cover;
    cursor: pointer;
    color: #fff;
    font-size: 12px;
    height: 31px;
    width: 25px;

    .map-text:after {
      background-color: white;
      border-radius: 10px;
      content: 'empty';
      color: white;
      font-size: 0px;
      height: 7px;
      left: 9px;
      position: absolute;
      top: 9px;
      width: 7px;
    }
  }

  .land-bottom-section {
    background-color: ${Colors.accent.grey7.standard};
    padding: 50px 0;

    .land-more-info {
      margin-bottom: 25px;
    }

    a:link,
    a:visited,
    a:hover,
    a:active {
      color: ${Colors.primary.claytonBlue.standard};
      font-weight: normal;
      text-decoration: none;
    }

    a.tel {
      text-decoration: underline;
    }

    .label.large {
      text-transform: none;
    }

    .constrained-width {
      display: flex;
      flex-direction: column;
    }

    h2 {
      margin-bottom: 10px;
    }

    .land-broker {
      margin-bottom: 10px;
    }

    .more-details {
      margin-bottom: 10px;
      margin-top: 10px;

      a:link,
      a:visited,
      a:hover,
      a:active {
        font-weight: bold;
      }
    }

    .land-disclaimer {
      .caption,
      a {
        font-size: 12px;
      }
    }
  }

  @media screen and (min-width: ${desktop_breakpoint}px) {
    .carousel.carousel-slider button.control-prev,
    .carousel.carousel-slider button.control-prev:hover {
      left: 0;
      transform: translate(-50%, -50%);
      top: 50%;
    }

    .carousel.carousel-slider button.control-next,
    .carousel.carousel-slider button.control-next:hover {
      right: 0;
      transform: translate(50%, -50%);
      top: 50%;
    }
  }

  @media screen and (min-width: ${desktop_breakpoint_extended}px) {
    .land-info {
      padding-left: 50px;
      width: 50%;
    }

    .land-slideshow-container {
      width: 50%;
    }

    .land-slideshow {
      margin: 0;
      width: 50%;
    }

    .land-top-section {
      flex-direction: row;
    }

    .control-dots {
      display: block;
    }

    .land-description {
      .listing-description {
        max-width: 600px;
      }
      a:link,
      a:visited,
      a:hover,
      a:active {
        text-decoration: none;
      }
    }

    .land-redundant-address {
      display: block;
    }

    .land-bottom-section {
      flex-direction: row;

      .constrained-width {
        flex-direction: row;
      }

      .land-more-info {
        padding-right: 25px;
        margin-bottom: 0;
        width: 50%;

        .tel {
          text-decoration: none;
          cursor: default;
          color: ${Colors.accent.grey1.standard};
        }
      }

      .land-disclaimer {
        align-items: center;
        border-left: 1px solid ${Colors.accent.grey5.standard};
        display: flex;
        padding-left: 25px;
        width: 50%;
      }
    }
  }
`;

export default LandDetailsStyles;
